import React from 'react';
import {FormattedMessage} from "react-intl";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Divider, List, ListItemButton, ListItemIcon, ListItemText, Stack,
} from "@mui/material";
import {DataGroupDto} from "../../../../../modules/account/dto/DataGroupDto";
import CloseButton from "../../../../../components/buttons/CloseButton";
import {DepartmentDto} from "../../../../../modules/account/dto/DepartmentDto";

export type DataGroupSelectDialogProps = {
    open: boolean;
    dataGroups: Array<DataGroupDto>;
    onSelect: (value: string) => void;
    onClose: () => void;
};

const DataGroupSelectDialog: React.FC<DataGroupSelectDialogProps> = (props) => {

    const _handleCancel = () => {
        props.onClose();
    };

    const _handleSelect = (item: DataGroupDto) => {
        props.onSelect(item.id);
        props.onClose();
    }

    const _renderChildren = (children: Array<DataGroupDto>, level: number) => {
        return (
            <List component="div" disablePadding>
                {
                    children.map((child, index) => {
                        return (
                            <div>
                                <ListItemButton key={child.id} sx={{pl: 4 * level}}
                                                onClick={() => _handleSelect(child)}>
                                    <ListItemText primary={child.name} secondary={child.code}/>
                                </ListItemButton>
                                {child.children ? _renderChildren(child.children, level + 1) : null}
                            </div>
                        )
                    })
                }
            </List>
        )
    }

    return (
        <Dialog open={props.open} onClose={_handleCancel} fullWidth={true}>
            <DialogTitle>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <FormattedMessage id={'ACCOUNT_DATA_GROUP_SELECT'}/>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <List>
                    {
                        props.dataGroups.map((item, index) => {
                            return (
                                <div key={item.id}>
                                    <ListItemButton onClick={() => _handleSelect(item)}>
                                        <ListItemText primary={item.name} secondary={item.code}/>
                                    </ListItemButton>
                                    {item.children ? _renderChildren(item.children, 1) : null}
                                    <Divider sx={{mt: 2, mb: 2}}/>
                                </div>
                            )
                        })
                    }
                </List>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={_handleCancel}/>
            </DialogActions>
        </Dialog>
    );
};

export default DataGroupSelectDialog;
